import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import { Car, Loader2, AlertCircle } from 'lucide-react';
export function DriverLoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const {
        error: authError
      } = await supabase.auth.signInWithPassword({
        email,
        password
      });
      if (authError) throw authError;
      navigate('/driver/app');
    } catch (err: any) {
      setError(err.message || 'Error al iniciar sesión');
    } finally {
      setLoading(false);
    }
  };
  return <div className="min-h-screen bg-[#0B0B0B] flex flex-col items-center justify-center p-6 text-white" data-id="element-4439">
      <div className="w-full max-w-sm space-y-8" data-id="element-4440">
        <div className="text-center" data-id="element-4441">
          <div className="w-16 h-16 bg-[#006847] rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-lg shadow-[#006847]/20" data-id="element-4442">
            <Car className="w-8 h-8 text-white" data-id="element-4443" />
          </div>
          <h1 className="text-3xl font-black tracking-tight" data-id="element-4444">NOIZA Driver</h1>
          <p className="text-white/50 mt-2 text-sm" data-id="element-4445">
            Inicia sesión para empezar a recibir viajes.
          </p>
        </div>

        <form onSubmit={handleLogin} className="space-y-4" data-id="element-4446">
          <div data-id="element-4447">
            <label className="block text-xs font-bold text-white/50 uppercase tracking-wider mb-2" data-id="element-4448">
              Correo electrónico
            </label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} className="w-full bg-[#141414] border border-white/10 rounded-xl px-4 py-3.5 text-white placeholder:text-white/20 focus:outline-none focus:border-[#006847] focus:ring-1 focus:ring-[#006847] transition-all" placeholder="conductor@noiza.com" required data-id="element-4449" />
          </div>

          <div data-id="element-4450">
            <label className="block text-xs font-bold text-white/50 uppercase tracking-wider mb-2" data-id="element-4451">
              Contraseña
            </label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} className="w-full bg-[#141414] border border-white/10 rounded-xl px-4 py-3.5 text-white placeholder:text-white/20 focus:outline-none focus:border-[#006847] focus:ring-1 focus:ring-[#006847] transition-all" placeholder="••••••••" required data-id="element-4452" />
          </div>

          {error && <div className="p-4 bg-red-500/10 border border-red-500/20 rounded-xl flex items-start gap-3 text-red-400 text-sm" data-id="element-4453">
              <AlertCircle className="w-5 h-5 shrink-0" data-id="element-4454" />
              <p data-id="element-4455">{error}</p>
            </div>}

          <button type="submit" disabled={loading || !email || !password} className="w-full bg-[#006847] hover:bg-[#005a3d] disabled:bg-white/5 disabled:text-white/30 text-white font-bold py-4 rounded-xl transition-all flex items-center justify-center gap-2 mt-4" data-id="element-4456">
            {loading ? <Loader2 className="w-5 h-5 animate-spin" data-id="element-4457" /> : 'Ingresar'}
          </button>
        </form>
      </div>
    </div>;
}